import { Link, NavLink } from 'react-router-dom'
import { BookOpen, Download } from 'lucide-react'

const APP_STORE_URL = 'https://apps.apple.com/gb/app/bukito/id6756301072'

const navLinkClass = ({ isActive }) =>
  `inline-flex h-10 items-center rounded-lg px-3 text-sm font-bold transition-colors ${
    isActive
      ? 'bg-primary-50 text-primary-700'
      : 'text-text-primary hover:bg-bg-soft hover:text-primary-700'
  }`

// Global top navigation used across every page. Brand → home, plus the two
// primary destinations: browse the curated lists and download the app.
const SiteHeader = () => (
  <header className="sticky top-0 z-30 border-b border-gray-100 bg-bg-surface/95 backdrop-blur">
    <div className="container-custom">
      <div className="flex min-h-[72px] items-center justify-between gap-3 py-3">
        <Link to="/" className="flex min-w-0 items-center gap-3 shrink-0" aria-label="Bukito home">
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-50">
            <img src="/brand-mark.png" alt="" className="h-8 w-8" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-2xl font-semibold tracking-[0.01em] text-[#2563EB]">bukito</span>
            <span className="mt-1 hidden text-xs font-bold text-text-secondary sm:block">
              Reading companion for families
            </span>
          </span>
        </Link>

        <div className="flex items-center gap-2 sm:gap-3">
          <nav className="hidden items-center gap-1 rounded-lg border border-gray-100 bg-bg-surface p-1 shadow-soft sm:flex">
            <NavLink to="/" end className={navLinkClass}>
              Home
            </NavLink>
            <NavLink to="/lists" className={navLinkClass}>
              Book lists
            </NavLink>
          </nav>

          <NavLink
            to="/lists"
            className={({ isActive }) =>
              `inline-flex h-10 items-center justify-center rounded-lg px-3 text-sm font-bold sm:hidden ${
                isActive ? 'bg-primary-50 text-primary-700' : 'text-primary-700'
              }`
            }
          >
            <BookOpen size={18} />
            <span className="sr-only">Book lists</span>
          </NavLink>

          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex h-11 items-center justify-center gap-2 rounded-lg bg-primary-500 px-4 text-sm font-bold text-white shadow-button transition-colors hover:bg-primary-600"
          >
            <Download size={17} />
            <span className="hidden sm:inline">Download app</span>
            <span className="sm:hidden">Get app</span>
          </a>
        </div>
      </div>
    </div>
  </header>
)

export default SiteHeader
